<div class="row">
  <div class="column twelve">
    <h3 class="billing-action-title"><span class="title-text"> Delete payment </span></h3>

    <div class="row pad-top-20">
      @if (allowDelete === true) {
        <div class="column twelve">
          <div class="pad-bottom-20">
            <span
              dsContent
              [contentPath]="'billing.deletePaymentWarning'"
              applicationDependentCopy="true"
            ></span>
          </div>
          <div class="flex items-center">
            <button
              ds-button
              class="-error"
              (click)="confirmDelete()"
              [disabled]="(roleService.isAuthorized('deletemyacctpayment') | async) === false"
              aria-label="Delete Payment"
              data-cy="billAccountDeleteScheduledPaymentButton"
            >
              Delete Payment
            </button>
            <a
              class="margin-left-8 caption"
              href="javascript:void(0);"
              title="Cancel"
              (click)="close()"
            >
              <span dsContent [contentPath]="'shared.cancel'"></span>
            </a>
          </div>
        </div>
      }

      @if (allowDelete !== true) {
        <div class="column twelve">
          <div><span dsContent [contentPath]="'billing.sameDayCreditCardNoModify'"></span></div>
          <div class="pad-top-20">
            <a
              href="javascript:void(0);"
              class="caption pad-top-20"
              title="Cancel"
              (click)="close()"
            >
              <span dsContent [contentPath]="'shared.cancel'"></span>
            </a>
          </div>
        </div>
      }
    </div>
  </div>
</div>
